/* global document */

export default function SettingsDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  userService,
  oversightDataService
) {
  const vm = this;

  vm.isProcessingComplete = true;
  vm.canEdit = userService.getUserPermission('displayOversightAddLink');
  vm.canDelete = userService.getUserPermission('displayOversightDeleteLink');
  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSaveSettings = _handleSaveSettings;
  vm.handleExpandSettingsSection = _handleExpandSettingsSection;
  vm.IsValidControl = _IsValidControl;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    _refresh();
    // SSUtil.applyTooltips(angular.element('#divDialogContainer'));
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.oversight.settingsDialog);
  }

  function _handleSaveSettings() {
    const dfdSave = $q.defer();
    if ($scope.editAgendaSettingsForm.$valid) {
      vm.isProcessingComplete = false;
      console.log('save settings');

      oversightDataService.saveSettings(vm.settings).then((response) => {
        if (response.data) {
          alerts.success('The Agenda Settings has been saved successfully.');
          $rootScope.$broadcast('refreshAgendaSettings');
          ssDialogService.hide(ssDialogService.dialogs.oversight.settingsDialog);
        } else {
          alerts.error('Error occurred while saving agenda Settings.');
        }
        vm.isProcessingComplete = true;
        dfdSave.resolve();
      });
    } else {
      _hasValidationError();
      dfdSave.reject();
    }
  }

  function _refresh() {
    vm.isProcessingComplete = false;
    const dfdRefresh = $q.defer();

    vm.isProcessingComplete = true;
    dfdRefresh.resolve();

    return dfdRefresh.promise;
  }

  // Expand/Collapse
  function _handleExpandSettingsSection($event, section) {
    vm[`${section}IsExpanded`] = !vm[`${section}IsExpanded`];
  }

  function _IsValidControl(ctrl) {
    return ($scope.editAgendaSettingsForm)
      && (($scope.editAgendaSettingsForm.$submitted && ctrl.$invalid) || (ctrl.$dirty && ctrl.$invalid));
  }

  function _hasValidationError() {
    const sections = document.querySelectorAll('.agenda--expand-section');

    angular.forEach(sections, (section) => {
      const invalid = section.parentElement.parentElement.querySelector('.ng-invalid');
      if (invalid && invalid !== null) {
        angular.element(section).addClass('invalid');
      } else { angular.element(section).removeClass('invalid'); }
    });
  }
}

SettingsDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'userService',
  'oversightDataService'
];
